import Navbar from '../Navbar/Navbar'
import Footer from '../Home/Footer'
import Commercial from '../Commercial/commercial'

const Commercialpage = () => {
    return (
        <div>
        <Navbar/>
        <Commercial/>


        <Footer/>
    

        </div>
    )
}

export default Commercialpage